<template>
  <div>
    <div>
      {{ payment.payment_user_name }} <span
        v-if="$i18n.locale === 'ja'"
        style="font-size: 0.9em"
      >様</span>
    </div>
    <div>{{ payment.payment_user_department }}</div>
    <div class="caption text-grey">
      〒{{ payment.postal_code.slice(0, 3) }}-{{ payment.postal_code.slice(3,7) }}&nbsp;
      {{ payment.address1 }}&nbsp;
      {{ payment.address2 }}&nbsp;
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      payment: {
        type: Object,
        required: true
      }
    }
  }
</script>
